import React from 'react';
import Head from "next/head";
import { NextSeo } from "next-seo";
import { seoFunct } from "../../config/next-seo.config.js";
import { withRouter } from "next/router";
import HomeNav from '../Home/HomeNav.jsx';
import HomeFooter from '../Home/HomeFooter.jsx';
import revampData from "../../data/revampData.json";
import HighlightCard from "../../revampComponents/HighlightCard";
import FeaturesCard from "../../revampComponents/FeaturesCard";
import Banner from "../../revampComponents/Banner";
import { reorderByOrderNo } from '../../config/constants.js';
const CheckInApp = () => {
  const checkInAppHighlight = revampData.data.listCheckInAppHighlights.data;
  const checkInAppFeatures = revampData.data.listCheckInAppFeatureCards.data;
  const checkInAppBanner = revampData.data.listCallToActionBanner.data;
  const reorderedData = reorderByOrderNo(checkInAppFeatures);
  return <div className='font-figtree' data-sentry-component="CheckInApp" data-sentry-source-file="CheckInApp.jsx">
      <NextSeo {...seoFunct("revampCheckInAppSeo")} data-sentry-element="NextSeo" data-sentry-source-file="CheckInApp.jsx" />
      <HomeNav data-sentry-element="HomeNav" data-sentry-source-file="CheckInApp.jsx" />
      <HighlightCard data={checkInAppHighlight} data-sentry-element="HighlightCard" data-sentry-source-file="CheckInApp.jsx" />
      <FeaturesCard featuresData={reorderedData} data-sentry-element="FeaturesCard" data-sentry-source-file="CheckInApp.jsx" />
      <Banner bannerData={checkInAppBanner} data-sentry-element="Banner" data-sentry-source-file="CheckInApp.jsx" />
      <HomeFooter data-sentry-element="HomeFooter" data-sentry-source-file="CheckInApp.jsx" />

      <style jsx>{`
        .main-container {
          width: 100%;
        }
      `}</style>
    </div>;
};
export default withRouter(CheckInApp);